import React from 'react';
import useTranslate from '../../../../../../../customHooks/useTranslate';

interface StatCardProps {
    title: string;
    children: React.ReactNode;
}
const StatCard = ({ title, children }: StatCardProps) => {
    const translate = useTranslate();
    return (
        <div className='competitor-viewer__stat-card'>
            <h3 className='competitor-viewer__stat-card__title'>
                {translate(title)}
            </h3>
            {children}
        </div>
    );
};

export default StatCard;
